module.exports = __webpack_public_path__ + "static/media/Serena.05e1a150.png";